<script>
import MenuItem from './MenuItem.vue'
import appConfig from "@/app.config";
import axios from 'axios';

export default {
  components: {
    MenuItem,
  },

  props: {
    editor: {
      type: Object,
      required: true,
    },
    thisBoard: {
      type: Object,
    },
  },
  data() {
    return {
      supportMembers: [],
      altongHTML: `
        <table class="tableWrapper">
          <tr>
            <th colspan="1" rowspan="1">
              <p><span style="color: #5a6d90; font-size: 12pt">대구여성인권센터</span><span style="font-size: 10pt"> </span></p>
              <p style="text-align: center">
                <span style="color: rgb(63, 81, 181); font-size: 24pt">알</span> 
                <span style="color: rgb(88, 49, 147); font-size: 22pt">리고 </span>
                <span style="color: rgb(63, 81, 181); font-size: 24pt">통</span> 
                <span style="color: rgb(88, 49, 147); font-size: 22pt">하는 소식지</span>
              </p>
              <p style="text-align: right"><span style="color: #5a6d90; font-size: 11pt">2099년 0월 알통 00호</span></p>
            </th>
          </tr>
        </table>

        <table>
          <tr>
            <th colspan="1" rowspan="1">
              <p style="text-align: center">
                <span style="font-size: 16pt"> 🏄‍♂️ </span>
                <strong>
                  <span style="font-size: 16pt">0월 활동소식을 전합니다</span>
                </strong>
                <span style="font-size: 16pt"> 🌴</span>
              </p>
            </th>
          </tr>
        </table>

        <p></p>
        <ul>
          <li><p><span style="font-size: 11pt">0월 0일(월) ㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇ</span></p></li>
          <li><p><span style="font-size: 11pt">0월 0일(화) ㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇ</span></p></li>
          <li><p><span style="font-size: 11pt">0월 0일(수) ㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇ</span></p></li>
          <li><p><span style="font-size: 11pt">0월 0일(목) ㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇ</span></p></li>
          <li><p><span style="font-size: 11pt">0월 0일(금) ㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇ</span></p></li>
          <li><p><span style="font-size: 11pt">0월 0일(토) ㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇ</span></p></li>
          <li><p><span style="font-size: 11pt">0월 8일(일) ㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇㅇ</span></p></li>
        </ul>

        <table>
          <tbody>
            <tr>
              <th colspan="1" rowspan="1">
                <p style="text-align: center">
                  <span style="font-size: 12pt">제목</span>
                </p>
              </th>
            </tr>
            <tr>
              <td>
                <h4>
                  <span style="font-size: 11pt">내용</span>
                </h4>
                <p></p>
                <p style="text-align: center;">
                  <strong>
                    <mark>더보기</mark>
                  </strong>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p></p>
        <table>
          <tr>
            <th colspan="1" rowspan="1">
              <p style="text-align: center">
                <strong>
                  <span style="color: ##3f51b5; font-size: 18pt">0월 </span>
                  <span style="color: #5a6d90; font-size: 18pt">반성매매 </span>
                  <span style="color: #5a6d90; font-size: 18pt"> 뉴스</span>
                </strong>
              </p>
            </th>
          </tr>
        </table>
        <strong><span style="font-size: 11pt">뉴스제목</span></strong>
        <p>
          <span style="font-size: 11pt">
            뉴스내용
          </span>
        </p>
        <p></p>
        <table>
          <tr>
            <th colspan="1" rowspan="1">
              <p style="text-align: center">
                <strong>
                  <span style="color: #5a6d90; font-size: 18pt">후원에 감사드립니다. </span>
                  <span style="color: #1b915a; font-size: 18pt">(후원금)</span>
                </strong>
              </p>
            </th>
          </tr>
        </table>
        <p style="text-align:center">
          <strong>
            <span style="color: #f5a6d90; font-size: 11pt">ㅇㅇㅇ, ㅇㅇㅇ, ㅇㅇㅇ, ㅇㅇㅇ</span>
          </strong>
        </p>
        <p></p>
        
        <p style="text-align:center">
          <span style="font-size: 10pt">“비공개 또는 일부 표기, 닉네임 표기 등을 원하실 경우 언제든지 사무국으로 연락 주세요”</span>
        </p>
        
        <p><strong><span style="color: #1b915a; font-size: 18pt">👏2099년 0월,</span></strong></p>
        <p><strong><span style="color: #1b915a; font-size: 18pt">대구여성인권센터 회원이 되어주셨습니다.😍</span></strong></p>
        <p style="text-align: center"><strong><span style="font-size: 11pt">🤗 ㅇㅇㅇ ✨</span></strong></p>
        <table>
          <tr>
            <th colspan="1" rowspan="1">
              <p style="text-align: center">
                <strong>
                  <span style="color: #5a6d90; font-size: 18pt">후원에 감사드립니다. </span>
                  <span style="color: #f17425; font-size: 18pt">(후원물품)</span>
                </strong>
              </p>
            </th>
          </tr>
        </table>
        <p style="text-align:center">
          <strong>
            <span style="color: #f5a6d90; font-size: 11pt">ㅇㅇㅇ, ㅇㅇㅇ, ㅇㅇㅇ, ㅇㅇㅇ</span>
          </strong>
        </p>
        <p></p>
        <p></p>
        <blockquote>
          <p><strong><span style="font-size: 11pt">사단법인 대구여성인권센터</span></strong></p>
          <p><strong><span style="font-size: 11pt">주소 : 대구광역시 중구 명덕로 279 벽산빌딩 403호</span></strong></p>
          <p><strong><span style="font-size: 11pt">전화번호 : 053-422-5898</span></strong></p>
          <p><strong><span style="font-size: 11pt">대표메일 : himne1004@hanmail.net</span></strong></p>
          <p><strong><span style="font-size: 11pt">홈페이지 : www.himne.org</span></strong></p>
        </blockquote>
        <p></p>`,
        tableHTML: `
        <table>
          <tbody>
            <tr>
              <th colspan="1" rowspan="1">
                <p style="text-align: center">
                  <span style="font-size: 11pt">제목</span>
                </p>
              </th>
            </tr>
            <tr>
              <td>
                <h4>
                  <span style="font-size: 11pt">내용</span>
                </h4>
                <p></p>
                <p style="text-align: center;">
                  <strong>
                    <mark>더보기</mark>
                  </strong>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p></p>`,
        // 테이블 2 : 가로 2칸 세로 1칸 (모바일에서는 세로 1열로 표시)
        tableHTML2: `
        <table class="table-2col" style="border-spacing: 0 15px;">
          <tbody>
            <tr>
              <td colspan="1" rowspan="1" style="font-size: 11pt;padding-right: 15px;">내용</td>
              <td class="table-2col-spacer" colwidth="15px">&nbsp;</td>
              <td colspan="1" rowspan="1" style="font-size: 11pt;padding-left: 15px;">내용</td>
            </tr>
          </tbody>
        </table>
        <p></p>`,
        // 제목없는 1칸 테이블
        tableHTML3: `
        <table>
          <tbody>
            <tr>
              <td colspan="1" rowspan="1" style="font-size: 11pt;padding-left: 15px;">내용</td>
            </tr>
          </tbody>
        </table>
        <p></p>`,
      items: [
        {
          icon: 'undo-variant',
          title: '뒤로 되돌리기',
          altong: false,
          action: () => this.editor.chain().focus().undo().run(),
        },
        {
          icon: 'redo-variant',
          title: '앞으로 되돌리기',
          altong: false,
          action: () => this.editor.chain().focus().redo().run(),
        },
        {
          icon: 'window-close',
          title: '서식 제거',
          altong: false,
          action: () => this.editor.chain()
            .focus()
            .clearNodes()
            .unsetAllMarks()
            .run(),
        },
        {
          type: 'divider',
        },
        {
          icon: 'link',
          title: 'URL 링크',
          altong: false,
          action: () => this.setLink(),
        },
        {
          type: 'divider',
        },
        {
          icon: 'format-paint',
          title: '하이라이트',
          altong: false,
          action: () => this.editor.chain().focus().toggleHighlight().run(),
          isActive: () => this.editor.isActive('highlight'),
        },
        {
          icon: 'format-bold',
          title: '굵게',
          altong: false,
          action: () => this.editor.chain().focus().toggleBold().run(),
          isActive: () => this.editor.isActive('bold'),
        },
        {
          icon: 'format-italic',
          title: '기울게',
          altong: false,
          action: () => this.editor.chain().focus().toggleItalic().run(),
          isActive: () => this.editor.isActive('italic'),
        },
        {
          icon: 'format-underline',
          title: '밑줄',
          altong: false,
          action: () => this.editor.chain().focus().toggleUnderline().run(),
          isActive: () => this.editor.isActive('underline'),
        },
        {
          icon: 'format-strikethrough',
          title: '글자 줄긋기',
          altong: false,
          action: () => this.editor.chain().focus().toggleStrike().run(),
          isActive: () => this.editor.isActive('strike'),
        },
        {
          icon: 'format-header-1',
          title: 'H1 큰 제목',
          altong: false,
          action: () => this.editor.chain().focus().toggleHeading({ level: 1 }).run(),
          isActive: () => this.editor.isActive('heading', { level: 1 }),
        },
        {
          icon: 'format-header-2',
          title: 'H2 중간 제목',
          altong: false,
          action: () => this.editor.chain().focus().toggleHeading({ level: 2 }).run(),
          isActive: () => this.editor.isActive('heading', { level: 2 }),
        },
        {
          icon: 'format-header-3',
          title: 'H3 작은 제목',
          altong: false,
          action: () => this.editor.chain().focus().toggleHeading({ level: 3 }).run(),
          isActive: () => this.editor.isActive('heading', { level: 3 }),
        },
        {
          icon: 'format-header-4',
          title: 'H4 제목',
          altong: false,
          action: () => this.editor.chain().focus().toggleHeading({ level: 4 }).run(),
          isActive: () => this.editor.isActive('heading', { level: 4 }),
        },
        {
          icon: 'format-pilcrow',
          title: '크기 초기화',
          altong: false,
          action: () => this.editor.chain().focus().setParagraph().run(),
          isActive: () => this.editor.isActive('paragraph'),
        },
        {
          type: 'divider',
        },
        {
          icon: 'format-list-bulleted',
          title: '둥근 목차',
          altong: false,
          action: () => this.editor.chain().focus().toggleBulletList().run(),
          isActive: () => this.editor.isActive('bulletList'),
        },
        {
          icon: 'format-list-numbered',
          title: '숫자 목차',
          altong: false,
          action: () => this.editor.chain().focus().toggleOrderedList().run(),
          isActive: () => this.editor.isActive('orderedList'),
        },
        {
          icon: 'format-quote-open',
          title: '강조',
          altong: false,
          action: () => this.editor.chain().focus().toggleBlockquote().run(),
          isActive: () => this.editor.isActive('blockquote'),
        },
        {
          icon: 'format-page-break',
          title: '줄 작대기',
          altong: false,
          action: () => this.editor.chain().focus().setHorizontalRule().run(),
        },
        // 들여쓰기 &nbsp;
        {
          icon: 'format-indent-increase',
          title: '들여쓰기',
          altong: false,
          action: () => this.editor.chain().focus().insertContent('    ').run(),
          isActive: () => this.editor.isActive('textStyle', {textIndent: '2em'}),
        },
        {
          type: 'divider',
        },
        {
          icon: 'format-align-left',
          title: '왼쪽 정렬',
          altong: false,
          action: () => this.editor.chain().focus().setTextAlign('left').run(),
          isActive: () => this.editor.isActive({textAlign: 'left'}),
        },
        {
          icon: 'format-align-center',
          title: '가운데 정렬',
          altong: false,
          action: () => this.editor.chain().focus().setTextAlign('center').run(),
          isActive: () => this.editor.isActive({textAlign: 'center'}),
        },
        {
          icon: 'format-align-right',
          title: '오른쪽 정렬',
          altong: false,
          action: () => this.editor.chain().focus().setTextAlign('right').run(),
          isActive: () => this.editor.isActive({textAlign: 'right'}),
        },
        {
          icon: 'code-tags',
          title: '코드블럭',
          altong: false,
          action: () => this.editor.chain().focus().toggleCodeBlock().run(),
          isActive: () => this.editor.isActive('codeBlock'),
        },
        {
          icon: 'lead-pencil',
          title: 'purple',
          altong: false,
          action: () => this.editor.chain().focus().setColor('#583193').run(),
          isActive: () => this.editor.isActive('textStyle', {color: '#583193'}),
        },
        {
          icon: 'lead-pencil',
          title: 'red',
          altong: false,
          action: () => this.editor.chain().focus().setColor('#f13a3a').run(),
          isActive: () => this.editor.isActive('textStyle', {color: '#f13a3a'}),
        },
        {
          icon: 'lead-pencil',
          title: 'green',
          altong: false,
          action: () => this.editor.chain().focus().setColor('#1b915a').run(),
          isActive: () => this.editor.isActive('textStyle', {color: '#1b915a'}),
        },
        {
          icon: 'lead-pencil',
          title: 'blue',
          altong: false,
          action: () => this.editor.chain().focus().setColor('#3f51b5').run(),
          isActive: () => this.editor.isActive('textStyle', {color: '#3f51b5'}),
        },
        {
          icon: 'lead-pencil',
          title: 'yellow',
          altong: false,
          action: () => this.editor.chain().focus().setColor('#f17425').run(),
          isActive: () => this.editor.isActive('textStyle', {color: '#f17425'}),
        },
        {
          icon: 'lead-pencil',
          title: 'grey',
          altong: false,
          action: () => this.editor.chain().focus().setColor('#5a6d90').run(),
          isActive: () => this.editor.isActive('textStyle', {color: '#5a6d90'}),
        },
        {
          icon: 'lead-pencil',
          title: 'dark',
          altong: false,
          action: () => this.editor.chain().focus().unsetColor().run(),
          isActive: () => this.editor.isActive('textStyle', {color: '#0d0d0d'}),
        },
        {
          type: 'divider',
        },
        {
          icon: '',
          title: '폰트 10',
          altong: false,
          action: () => this.editor.chain().focus().setFontSize('10pt').run(),
          isActive: () => this.editor.isActive('textStyle', {fontSize: '10pt'}),
        },
        {
          icon: '',
          title: '폰트 11',
          action: () => this.editor.chain().focus().setFontSize('11pt').run(),
          isActive: () => this.editor.isActive('textStyle', {fontSize: '11pt'}),
        },
        {
          icon: '',
          title: '폰트 12',
          altong: false,
          action: () => this.editor.chain().focus().setFontSize('12pt').run(),
          isActive: () => this.editor.isActive('textStyle', {fontSize: '12pt'}),
        },
        {
          icon: '',
          title: '폰트 14',
          altong: false,
          action: () => this.editor.chain().focus().setFontSize('14pt').run(),
          isActive: () => this.editor.isActive('textStyle', {fontSize: '14pt'}),
        },
        {
          icon: '',
          title: '폰트 16',
          altong: false,
          action: () => this.editor.chain().focus().setFontSize('16pt').run(),
          isActive: () => this.editor.isActive('textStyle', {fontSize: '16pt'}),
        },
        {
          icon: '',
          title: '폰트 18',
          altong: false,
          action: () => this.editor.chain().focus().setFontSize('18pt').run(),
          isActive: () => this.editor.isActive('textStyle', {fontSize: '18pt'}),
        },
        {
          icon: 'table-large',
          title: '알통 샘플',
          altong: true,
          action: () => this.editor.chain().focus().insertContent(this.altongHTML, { parseOptions: { preserveWhitespace: false }}).run(),
        },
        {
          icon: 'table',
          title: '제목있는표만들기',
          altong: false,
          action: () => this.editor.chain().focus().insertContent(this.tableHTML, { parseOptions: { preserveWhitespace: false }}).run(),
        },
        {
          icon: 'window-maximize',
          title: '제목없는표만들기',
          altong: false,
          action: () => this.editor.chain().focus().insertContent(this.tableHTML3, { parseOptions: { preserveWhitespace: false }}).run(),
        },
        {
          icon: 'numeric-2-box',
          title: '가로2칸',
          altong: false,
          action: () => this.editor.chain().focus().insertContent(this.tableHTML2, { parseOptions: { preserveWhitespace: false }}).run(),
        },
        {
          icon: 'table-cancel',
          title: '테이블 삭제',
          altong: false,
          action: () => this.editor.chain().focus().deleteTable().run(),
        },
        {
          icon: 'format-float-left',
          title: '이미지 왼쪽',
          altong: false,
          action: () => this.editor.chain().focus().updateAttributes("image", { float: "left"}).run(),
          isActive: () => this.editor.isActive('image', {float: 'left'}),
        },
        {
          icon: 'format-float-center',
          title: '이미지 기본',
          altong: false,
          action: () => this.editor.chain().focus().updateAttributes("image", { float: "default"}).run(),
          isActive: () => this.editor.isActive('image', {float: 'default'}),
        },
        {
          icon: 'format-float-right',
          title: '이미지 오른쪽',
          altong: false,
          action: () => this.editor.chain().focus().updateAttributes("image", { float: "right"}).run(),
          isActive: () => this.editor.isActive('image', {float: 'right'}),
        },
        {
          icon: 'account-cash',
          title: '회원전체추가',
          altong: false,
          action: () => this.getSupportMembers(),
          isActive: () => this.editor.isActive('mention'),
        },
        {
          icon: 'account-arrow-left',
          title: '회원1명만추가',
          altong: false,
          action: () => this.setOneAltongMember(),
          isActive: () => this.editor.isActive('mention'),
        },
        /*
        {
          icon: '',
          title: '이모지',
          action: () => this.editor.chain().focus().insertContent('🎶').run(),
        },
        */
      ],
    }
  },
  methods: {
    // a 링크
    setLink() {
      const previousUrl = this.editor.getAttributes('link').href
      const url = window.prompt('링크 URL주소를 입력해주세요', previousUrl)
      // cancelled
      if (url === null) {
        return
      }
      // empty
      if (url === '') {
        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .unsetLink()
          .run()

        return
      }

      // update link
      this.editor
        .chain()
        .focus()
        .extendMarkRange('link')
        .setLink({ href: url })
        .run()
    },
    // a 링크
    setOneAltongMember() {
      const member = window.prompt('추가할 텍스트를 넣어주세요')
      // cancelled
      if (member === null) {
        return
      }
      this.editor.chain().focus().insertContent({type: "mention", attrs: {id: member}}).run();
    },
    // 정,후원회원 전체 추가
    async insertMembers() {
      try {
        const promises = this.supportMembers.map(member => {
          if (this.editor.isActive) {
            return this.editor.chain().focus().insertContent({type: "mention", attrs: {id: member}}).run();
          }
        });

        await Promise.all(promises);
      } catch (error) {
        console.log('fail - insertMembers', error);
      }
    },
    // 정,후원회원 리스트 가져오자
    getSupportMembers() {
      this.loadingBar(true);
      axios({
        method: 'POST', url: appConfig.fastapi + '/board/jy_board_altong_member_list',
        headers: {
          'access-token': this.token
        },
        data: {
          "work": "getSupportMembers",
        }
      })
      .then((response) => {
        if (response.data.status == 'success') {
          this.supportMembers = response.data.supportMembers;
          this.insertMembers();
        }
      })
      .catch((error) => {
        this.$notify({ type: 'error', duration: 3000, 'title': '실패', text: error.response.data.detail })
      })
      .finally(() => {
        this.loadingBar(false);
      })
    },
    loadingBar(val) {
      if (val === true) {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";
      } else {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }
    },
  },
}
</script>

<template>
  <div class="menubar">
    <template v-for="(item, index) in items">
      <!-- 비밀글일 때는 구분선도 숨김 -->
      <div v-if="item.type === 'divider' && (!thisBoard || !thisBoard.jsonData || !thisBoard.jsonData.use_secret)" class="tiptap-divider" :key="`divider${index}`" />
      <div v-else>
        <!-- 비밀글일 때 -->
        <div v-if="thisBoard && thisBoard.jsonData && thisBoard.jsonData.use_secret">
          <menu-item v-if="item.title === '뒤로 되돌리기' || item.title === '앞으로 되돌리기'" :key="index" v-bind="item" :thisBoard="thisBoard"/>
        </div>
        <!-- 비밀글이 아닐 때 -->
        <div v-else>
          <!-- 알통기능 사용한다면 -->
          <div v-if="thisBoard.jsonData.use_altong==true">
            <menu-item :key="index" v-bind="item" :thisBoard="thisBoard"/>
          </div>
          <!-- 알통기능 사용안할 때 -->
          <div v-else>
            <menu-item v-if="item.altong==false" :key="index" v-bind="item" :thisBoard="thisBoard"/>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>